/** App download links */

import Grid from '@mui/material/Unstable_Grid2';
import classNames from 'classnames';
import Image from 'next/image';

type Props = {
  mt?: number;
  mb?: number;
  my?: number;
  className?: string;
  maxWidth?: number;
  linksLocation?: string; // used for tracking to specify link location on the page
  onLinkClick?: (platform, location?) => void;
};

export const Platforms = {
  ANDROID: 'android',
  IOS: 'ios',
};

const AppDownloadLinks = (props: Props) => {
  const { mt, mb, my, className, maxWidth, onLinkClick } = props;

  return (
    <div
      className={classNames('app-ads', className, {
        [`mt-${mt}-i`]: mt || mt === 0,
        [`mb-${mb}-i`]: mb || mb === 0,
        [`my-${my}-i`]: my || my === 0,
      })}
      style={{
        maxWidth: maxWidth || 398,
      }}
    >
      <Grid container justifyContent="center" className="app-links" wrap="nowrap">
        <a
          className="app-link appstore"
          href="https://apps.apple.com/ee/app/yaga/id1509750294"
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            onLinkClick(Platforms.IOS, props.linksLocation);
          }}
        >
          <Image src={'/images/appstore.png'} width={796} height={235} alt="appstore" />
        </a>

        <a
          className="app-link playstore"
          href="https://play.google.com/store/apps/details?id=com.yaga.yagashop"
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            onLinkClick(Platforms.ANDROID, props.linksLocation);
          }}
        >
          <Image src={'/images/playstore.png'} width={796} height={235} alt="playstore" />
        </a>
      </Grid>
    </div>
  );
};

export default AppDownloadLinks;
